export type CsvCell = string | number

function escapeCell(cell: CsvCell): string {
    let value = String(cell)

    if (/^[=+\-@\t\r]/.test(value)) value = `'${value}`
    if (/[",\r\n]/.test(value)) value = `"${value.replace(/"/g, '""')}"`

    return value
}

export function toCsv(rows: CsvCell[][]): string {
    return rows.map(row => row.map(escapeCell).join(',')).join('\r\n')
}

export function downloadCsv(filename: string, rows: CsvCell[][]): void {
    const blob = new Blob(['﻿', toCsv(rows)], {
        type: 'text/csv;charset=utf-8'
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')

    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    link.remove()
    URL.revokeObjectURL(url)
}
